import { render, staticRenderFns } from "./LinkAdminToSheet.vue?vue&type=template&id=06232ddb&scoped=true&"
import script from "./LinkAdminToSheet.vue?vue&type=script&lang=js&"
export * from "./LinkAdminToSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06232ddb",
  null
  
)

export default component.exports